import * as React from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, Spinner, UncontrolledDropdown} from 'reactstrap';
import {FontAwesomeIcon} from '../../../../components/ui/FontAwesomeIcon';
import {IColumn, IDropdown} from '../interfaces';
import { useEffect, useState } from 'react';

interface IDropdownComponentProps {
  dropdown: IDropdown,
  column: IColumn,
  loadingStates: {  period: boolean; survey: boolean; question: boolean; measure: boolean; segment: boolean },
  inputs: Map<string, boolean>
  updateDropdown: (dropdownName: string, optionID: string | number) => void
  previousDropdownNameDependency: string
  previousDropdownSelectedOptions: string[]
}

export function DropdownComponent(props: IDropdownComponentProps) {
  const {
    dropdown,
    column,
    loadingStates,
    inputs,
    updateDropdown,
    previousDropdownNameDependency,
    previousDropdownSelectedOptions
  } = props;
  const [ isLoading, setIsLoading ] = useState(true);
  const [ disabled, setDisabled ] = useState(true);

  let currentChoice;
  const currentChoiceIndex = column ? dropdown.options.findIndex((item) => item.id === column[dropdown.name]) : -1;
  if (currentChoiceIndex > -1) {
    currentChoice = dropdown.options[currentChoiceIndex];
  }

  useEffect(() => {
    if (previousDropdownNameDependency.length === 0) {
      setDisabled(false);
      return;
    }
    if (previousDropdownSelectedOptions.includes(previousDropdownNameDependency)) {
      setDisabled(false);
    }
  }, [previousDropdownSelectedOptions]);
  useEffect(() => {
    if (loadingStates[dropdown.name]) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [loadingStates[dropdown.name]]);
  return (
    <div className="margin-bottom">
      <UncontrolledDropdown>
        <DropdownToggle caret outline color="dark" disabled={isLoading || disabled}>
          <div className="d-flex justify-content-between text-truncate">
            <strong>{dropdown.label}</strong> {renderDropdownSelection(dropdown, loadingStates[dropdown.name], currentChoice)}
            <span><FontAwesomeIcon icon="caret-down" fixedWidth/></span>
          </div>
        </DropdownToggle>
        <DropdownMenu className="user-select-dropdown-menu">
          <DropdownItem disabled>Select One</DropdownItem>
          {dropdown.options &&
              dropdown.options.map((option, index) => {
                return (
                    <DropdownItem
                        key={`${dropdown.name}-option-item` + index}
                        onClick={() => {
                          updateDropdown(dropdown.name, option.id);
                        }}
                        className="text-wrap border-top"
                        disabled={option.label === "Not Segments Found"}
                    >
                      {option.label}
                    </DropdownItem>
                );
              })}
        </DropdownMenu>
      </UncontrolledDropdown>
      <span className={'text-danger ' + (inputs.get(dropdown.name) ? 'd-none' : '')}>Please select an option</span>
    </div>
  );
}

const renderDropdownSelection = (dropdown, isLoading: boolean, currentChoice) => {
  if (isLoading) {
    return <Spinner style={{ width: '1.5rem', height: '1.5rem' }} />
  } else { return (
    (currentChoice ? currentChoice.label : 'None Selected')
  )
  }
}
